/**
 * This file is only need if you want to extract messages into JSON files in locales folder
 * AND if you are also using the object syntax instead of string syntax. \
 * Check the documentation section i18n for details
 */
import { translations } from 'locales/translations';
import { _t } from 'utils/messages';

export const messages = {
  // someThing: () => _t(translations.someThing,'default value'),
  name: () => _t(translations.AssetDistribution2.name),
  stocks: () => _t(translations.AssetDistribution2.stocks),
  mutual: () => _t(translations.AssetDistribution2.mutual),
  saving: () => _t(translations.AssetDistribution2.saving),
  gold: () => _t(translations.AssetDistribution2.gold),
  fixed: () => _t(translations.AssetDistribution2.fixed),
  commodity: () => _t(translations.AssetDistribution2.commodity),
  cryptocurrency: () => _t(translations.AssetDistribution2.crypto),
  forex: () => _t(translations.AssetDistribution2.forex),
  others: () => _t(translations.AssetDistribution2.others),
  real: () => _t(translations.AssetDistribution2.real),
  btn1: () => _t(translations.AssetDistribution2.btn1),
  btn2: () => _t(translations.AssetDistribution2.btn2),
};
